import { render, staticRenderFns } from "./WideModal.vue?vue&type=template&id=4017f9c0&"
import script from "./WideModal.vue?vue&type=script&lang=js&"
export * from "./WideModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports